module.exports = __webpack_public_path__ + "img/icon-slide0.b19d3fba.jpg";